import { CONTENT_TYPE, createPlainText, createEmoticon } from './utils';

const emoticonRE = /\[[^[]+?]/g;

// eslint-disable-next-line
// @ts-ignore
function parseEmoticon(node, iconUrls) {
    const result = [];
    const { value: nodeText } = node;
    // 切割点
    let flag = 0;
    let match = emoticonRE.exec(node.value);
    while (match) {
        const code = match[0];
        if (iconUrls[code]) {
            // 切割，match.index是匹配的第一个字符的位置
            const text = nodeText.slice(flag, match.index);
            result.push(createPlainText(text));

            result.push(createEmoticon(code, iconUrls[code]));
            flag += text.length + code.length;
        }
        match = emoticonRE.exec(node.value);
    }

    const text = nodeText.slice(flag, nodeText.length);
    result.push(createPlainText(text));

    return result;
}

// eslint-disable-next-line
// @ts-ignore
export const processEmoticon = iconUrls => contentAst =>
    // eslint-disable-next-line
    // @ts-ignore
    contentAst.reduce((result, node) => {
        if (node.type === CONTENT_TYPE.PLAIN_TEXT) {
            return result.concat(parseEmoticon(node, iconUrls));
        }

        return result.concat([node]);
    }, []);
